module.exports = "/wp-content/plugins/farmacy/assets/js/images/hamburger-icon-20acbc8fcc8a707fa2deb5169c0bd3fe.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/header-control-bar/hamburger-button/img/hamburger-icon.png
 ** module id = 566
 ** module chunks = 1 27 28 142
 **/